import { useState } from "react";

import { snackbarSuccessMessage } from "../Util/RouteConstants";
import EasySnackbar from "./EasySnackbar";

const autoHideDuration = 5000;
const snackbarMessageKey = "vjust-snackbarMessage";

export const setSnackbarMessage = (message: string) => {
  sessionStorage.setItem(snackbarMessageKey, message);
};

export const setSnackbarSuccessMessage = () => {
  sessionStorage.setItem(snackbarMessageKey, snackbarSuccessMessage);
};

const getSnackbarMessage = () => {
  return sessionStorage.getItem(snackbarMessageKey);
};

/**
 * Reads from the location state and renders a mui snackbar element on the page for 5 seconds
 * if there is a "snackbarMessage" key in the location state
 */
export default function SessionStorageSnackbar(): JSX.Element {
  const message = getSnackbarMessage();
  const [isOpen, setIsOpen] = useState<boolean>(!!message);

  setTimeout(() => {
    setSnackbarMessage("");
  }, autoHideDuration);

  return (
    <EasySnackbar
      alertProps={{ children: message, severity: "success" }}
      autoHideDuration={autoHideDuration}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    ></EasySnackbar>
  );
}
